import { useContext, useState } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { useForm } from 'react-hook-form';
import Cookies from 'universal-cookie';

import UseVerificationDigit from '@/hooks/UseVerificationDigit';

import CloseBtn from '../../../assets/images/icons/close_black_24dp.svg';
import GlobalContext from '../../../contexts/globalContext';
import HomeServices from '../../../services/home-services';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import Button from '../../atoms/button/button';
import Modal from '../../atoms/modal/modal';
import PaymentSummaryTable from '../../atoms/payment-summary-table/payment-summary-table';
import ChoiseModal from '../../molecules/choise-modal/choiseModal';
import ErrorModal from '../../molecules/error-modal/errorModal';
import PaymentMethod from '../../molecules/payment-method/payment-method';
import WhereConfirmation from '../../molecules/where-confirmation/where-confirmation';

import './payment-summary.scss';

const PaymentSummary = (props) => {
  const data = useStaticQuery(graphql`
    query GET_PORTAL_SERVICIOS_PASO_2 {
      allContentfulTemplate(
        filter: { titulo: { eq: "Pagos personas privado y público > Paso 2" } }
      ) {
        nodes {
          modal {
            nombre
            imagen {
              title
              file {
                url
              }
            }
            descripcion {
              raw
            }
            boton {
              copy
              redireccion
            }
          }
          migaDePan
          lista
          nombre
          referencias {
            ... on ContentfulTemplate {
              nombre
              lista
              spanMagenta
              number
              imagen {
                title
                file {
                  url
                }
                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
              }
              copyBoton
              redireccion
              referencias {
                ... on ContentfulTemplate {
                  nombre
                  tituloEnriquecido {
                    raw
                  }
                  subtitulo
                  listaJson {
                    name
                    value
                  }
                  imagen {
                    title
                    file {
                      url
                    }
                    gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                  }
                  copyBoton
                  redireccion
                }
              }
              descripcion {
                raw
              }
            }
          }
          secciones {
            imagen {
              title
                file {
                    url
                }
                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                svg {
                                publicURL
                }
            }
            nombre
            tituloEnriquecido {
              raw
            }
            spanMagenta
            subtitulo
            boton {
              copy
              redireccion
            }
          }
        }
      }
    }
  `);

  const contentInfo = data.allContentfulTemplate.nodes[0];

  const { gigyaContext, userInfoContext } = useContext(GlobalContext);
  const { setStepPage, contentType, creditData, setActiveModal, fluxType, haveIntermediateStep } =
    props;
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({ mode: 'onChange' });

  const { window } = useBrowserMode();
  const watchName = watch('name');
  const watchLastname = watch('lastname');
  const watchDocType = watch('resumeDocumentType');
  const watchDocument = watch('document');
  const watchEmail = watch('email');
  const watchTelephone = watch('cellphone');
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderButton, setLoaderButton] = useState(false);
  const [informativeAlert, setInformativeAlert] = useState(false);
  const [redirectionAlert, setRedirectionAlert] = useState(false);
  const [urlToPay, setUrlToPay] = useState('');

  const downloadFile = (url: any) => {
    axios
      .get(url, {
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(res.data, 'Preguntas frecuentes.pdf');
      });
  };

  const getPayload = (data) => {
    if (
      gigyaContext &&
      gigyaContext?.gigyaAccount &&
      userInfoContext &&
      userInfoContext?.data?.userJwt
    ) {
      const docType = gigyaContext?.gigyaAccount?.data?.docType;
      return {
        buyer: {
          document: gigyaContext?.gigyaAccount?.data?.docNumber,
          documentCompany: fluxType === 'factura' ? creditData?.owner?.document : '',
          documentType: docType,
          documentTypeCompany:
            fluxType === 'factura' ? creditData?.owner?.docType?.tipoDocumentoSAP : '',
          email: data.email,
          mobile: data.cellphone,
          name: `${gigyaContext?.gigyaAccount?.profile?.firstName} ${
            gigyaContext?.gigyaAccount?.data?.secondName
              ? gigyaContext?.gigyaAccount?.data.secondName
              : ''
          }`,
          surname: `${gigyaContext?.gigyaAccount?.profile?.lastName} ${
            gigyaContext?.gigyaAccount?.data?.secondLastName
              ? gigyaContext?.gigyaAccount?.data?.secondLastName
              : ''
          }`,
        },
        payments: creditData.credits.map((info) => {
          return {
            amount: {
              currency: 'COP',
              total: parseFloat(info.value),
            },
            category: fluxType,
            description: info.descrption,
            reference: info.code,
            objContrato: info.objContrato,
          };
        }),
        returnUrl:
          window.location.origin +
          (window?.location.hostname === 'localhost'
            ? '/pagos/confirmacion-estado-pago'
            : '/portal-servicios/pagos/confirmacion-estado-pago'),
        cancelUrl:
          window.location.origin +
          (window?.location.hostname === 'localhost' ? '/pagos' : '/portal-servicios/pagos'),
      };
    }
    return {
      buyer: {
        document: data.document,
        documentCompany: fluxType === 'factura' ? creditData?.owner?.document : '',
        documentType: data.resumeDocumentType,
        documentTypeCompany:
          fluxType === 'factura' ? creditData?.owner?.docType?.tipoDocumentoSAP : '',
        email: data.email,
        mobile: data.cellphone,
        name: data.name,
        surname: data.lastname,
      },
      payments: creditData.credits.map((info) => {
        return {
          amount: {
            currency: 'COP',
            total: parseFloat(info.value),
          },
          category: fluxType,
          description: info.descrption,
          reference: info.code,
          objContrato: info.objContrato,
        };
      }),
      returnUrl:
        window.location.origin +
        (window?.location.hostname === 'localhost'
          ? '/pagos/confirmacion-estado-pago'
          : '/portal-servicios/pagos/confirmacion-estado-pago'),
      cancelUrl:
        window.location.origin +
        (window?.location.hostname === 'localhost' ? '/pagos' : '/portal-servicios/pagos'),
    };
  };

  const onSubmit = async (data) => {
    if (gigyaContext) {
      setLoader(true);
      const config = {
        headers: {
          Authorization: userInfoContext.data?.userJwt ? userInfoContext.data?.userJwt : null,
        },
      };

      const payload = getPayload(data);
      setTimeout(() => {
        HomeServices.createSessionPlaceToPay(payload, config)
          .then((response: any) => {
            setLoader(false);
            if (response.status === 200) {
              if (response.errorCode === '') {
                const transactionData = {
                  reference: response.data.reference,
                  requestId: response.data.requestId,
                  references: creditData.credits.map((item) => {
                    return {
                      description: item.descrption,
                      code: item.code,
                    };
                  }),
                };
                const encriptedData = btoa(JSON.stringify(transactionData));

                const cookies = new Cookies();
                cookies.set('transactionData', encriptedData, {
                  path: '/',
                });

                setRedirectionAlert(true);
                setUrlToPay(response.data.request.fields[0].value);
              } else if (response.errorCode === '1') {
                setActiveModal(
                  <ErrorModal
                    title="Pago pendiente"
                    subtitle="Ahora mismo hay una transacción con las mismas referencias en estado pendiente, por favor, espere a que esta expire o intente de nuevo con otra obligación"
                    closeModal={() => setActiveModal(false)}
                    buttonCopy="Aceptar"
                    buttonEvent={() => setActiveModal(false)}
                  />,
                );
              } else if (response.errorCode === '2') {
                const transactionData = {
                  reference: response.data.reference,
                  requestId: response.data.requestId,
                  references: creditData.credits.map((item) => {
                    return {
                      description: item.descrption,
                      code: item.code,
                    };
                  }),
                };
                const encriptedData = btoa(JSON.stringify(transactionData));

                const cookies = new Cookies();
                const actTime = new Date().getTime();
                const expire = actTime + 60 * 15 * 1000 * 1;
                const expiresIn = new Date(expire);
                cookies.set('transactionData', encriptedData, {
                  path: '/',
                  expires: expiresIn,
                });
                setUrlToPay(response.data.request.fields[0].value);
                setInformativeAlert(true);
              }
            } else {
              setActiveModal(
                <ErrorModal
                  subtitle={response.userMessage}
                  closeModal={() => setActiveModal(false)}
                  buttonCopy="Aceptar"
                  buttonEvent={() => setActiveModal(false)}
                />,
              );
            }
          })
          .catch((e) => {
            setLoader(false);
            console.log(e);
            setActiveModal(
              <ErrorModal
                closeModal={() => setActiveModal(false)}
                buttonCopy="Aceptar"
                buttonEvent={() => setActiveModal(false)}
              />,
            );
          });
      }, 2000);
    }
  };

  const cancelTransalction = () => {
    const cookies = new Cookies();
    const transactionData = cookies.get('transactionData');

    if (transactionData) {
      const decripted = JSON.parse(atob(transactionData));
      if (gigyaContext && userInfoContext && userInfoContext.data?.userJwt && decripted) {
        const config = {
          headers: {
            Authorization: userInfoContext.data?.userJwt ? userInfoContext.data?.userJwt : null,
          },
        };

        const payload = `/${decripted.requestId}`;

        HomeServices.cancelPaymentPlaceToPay(payload, config)
          .then((response) => {
            setInformativeAlert(false);
            window.location.href =
              window.location.origin +
              (window?.location.hostname === 'localhost' ? '/pagos' : '/portal-servicios/pagos');
          })
          .catch((e) => {
            console.log(e);
            setInformativeAlert(false);
            window.location.href =
              window.location.origin +
              (window?.location.hostname === 'localhost' ? '/pagos' : '/portal-servicios/pagos');
          });
      }
    }
  };

  const cancelTransactionFromRedirect = () => {
    const cookies = new Cookies();
    const transactionData = cookies.get('transactionData');
    const token = cookies.get('token');

    if (transactionData) {
      const decripted = JSON.parse(atob(transactionData));
      if (gigyaContext && userInfoContext && userInfoContext.data?.userJwt && decripted) {
        const config = {
          headers: {
            Authorization: token,
          },
        };

        const payload = `/${decripted.requestId}`;
        setLoaderButton(true);
        HomeServices.cancelPaymentPlaceToPay(payload, config)
          .then((response) => {
            setRedirectionAlert(false);
            setLoaderButton(false);
          })
          .catch((e) => {
            console.log(e);
            setRedirectionAlert(false);
            setLoaderButton(false);
          });
      } else {
        const config = {
          headers: {
            Authorization: userInfoContext.data?.userJwt ? userInfoContext.data?.userJwt : null,
          },
        };

        const payload = `/${decripted.requestId}`;
        setLoaderButton(true);
        HomeServices.cancelPaymentPlaceToPay(payload, config)
          .then((response) => {
            setRedirectionAlert(false);
            setLoaderButton(false);
          })
          .catch((e) => {
            console.log(e);
            setRedirectionAlert(false);
            setLoaderButton(false);
          });
      }
    } else {
      setRedirectionAlert(false);
    }
  };

  const alertModal = () => {
    const modalData = contentInfo.secciones[0];
    return (
      <div className="o-payment__modal__container">
        <div className="o-payment__modal__container__closeBtn" onClick={() => cancelTransalction()}>
          <img src={CloseBtn} alt="closeButton" />
        </div>
        <div className="o-payment__modal__container__content">
          <div className="o-payment__modal__container__content__img">
            <img src={modalData.imagen[0].file.url} alt={modalData.imagen[0].file.title} />
          </div>
          <div className="o-payment__modal__container__content__title">
            <h2>{modalData.nombre.split('!')[0]}!</h2>
          </div>
          <div className="o-payment__modal__container__content__subtitle">
            <h2>{modalData.nombre.split('!')[1]}</h2>
          </div>
          <div className="o-payment__modal__container__content__descriptionOne">
            {modalData.tituloEnriquecido.raw &&
              documentToReactComponents(JSON.parse(modalData.tituloEnriquecido.raw))}
          </div>
          <div className="o-payment__modal__container__content__otherPay">
            <p>{modalData.subtitulo}</p>
          </div>
          <div className="o-payment__modal__container__content__buttons">
            <Button
              type="button"
              classname="primary"
              text="Cancelar"
              onClickAction={() => cancelTransalction()}
              isDisabled={false}
              loader={loaderButton}
            />
            <Button
              type="button"
              classname="secondary"
              text="Continuar"
              onClickAction={() => {
                setLoaderButton(true);
                window.location.href = urlToPay;
              }}
              isDisabled={false}
              loader={loaderButton}
            />
          </div>
        </div>
      </div>
    );
  };

  const redirectionModalEstructure = () => {
    const modalData = contentInfo.modal[0];
    return (
      <div className="o-payment__modal__container">
        <div
          className="o-payment__modal__container__closeBtn"
          onClick={() => cancelTransactionFromRedirect()}
        >
          <img src={CloseBtn} alt="closeButton" />
        </div>
        <div className="o-payment__modal__container__content">
          <div className="o-payment__modal__container__content__img">
            <img src={modalData.imagen[0].file.url} alt={modalData.imagen[0].file.title} />
          </div>
          <div className="o-payment__modal__container__content__title">
            <h2>Atención</h2>
          </div>
          <div className="o-payment__modal__container__content__descriptionOne">
            {modalData.descripcion.raw &&
              documentToReactComponents(JSON.parse(modalData.descripcion.raw))}
          </div>
          <div className="o-payment__modal__container__content__buttons">
            <Button
              type="button"
              classname="primary"
              text="Cancelar"
              onClickAction={cancelTransactionFromRedirect}
              isDisabled={false}
            />
            <Button
              type="button"
              classname="secondary"
              text="Continuar"
              onClickAction={() => (window.location.href = urlToPay)}
              isDisabled={false}
            />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="o-payment">
      {cancelConfirmation && (
        <ChoiseModal
          closeModal={() => setCancelConfirmation(false)}
          title="¿Estás seguro de cancelar esta transacción?"
          leftButtonCopy="NO"
          leftButtonEvent={() => {
            setCancelConfirmation(false);
          }}
          rightButtonCopy="SI"
          rightButtonEvent={() => {
            window.location.href =
              window?.location.hostname === 'localhost'
                ? `${window.location.origin}/pagos`
                : `${window.location.origin}/portal-servicios/pagos`;
          }}
        />
      )}
      {informativeAlert && (
        <Modal open={informativeAlert} onClose={() => cancelTransalction()}>
          {alertModal()}
        </Modal>
      )}
      {redirectionAlert && (
        <Modal open={redirectionAlert} onClose={() => cancelTransalction()}>
          {redirectionModalEstructure()}
        </Modal>
      )}
      <h1 className="o-payment__title">{contentInfo.nombre}</h1>
      <PaymentSummaryTable
        creditList={creditData.credits}
        contentInfo={contentInfo.referencias[0].lista}
        contentType={contentType}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <WhereConfirmation
          contentInfo={contentInfo.referencias[1]}
          setValue={setValue}
          errors={errors}
          register={register}
          gigyaContext={gigyaContext}
        />
        <PaymentMethod
          contentInfo={contentInfo.referencias[2].referencias}
          setStepPage={setStepPage}
          watchName={watchName}
          watchLastname={watchLastname}
          watchDocType={watchDocType}
          watchDocument={watchDocument}
          watchTelephone={watchTelephone}
          watchEmail={watchEmail}
          setCancelConfirmation={setCancelConfirmation}
          loader={loader}
          fluxType={fluxType}
          gigyaContext={gigyaContext}
          haveIntermediateStep={haveIntermediateStep}
        />
      </form>
      <div className="o-payment__pay-safe">
        <p>{contentInfo.referencias[3].nombre}</p>
        <div className="o-payment__pay-safe__img">
          {contentInfo.referencias[3].referencias.map((img, index) => {
            if (img.redireccion && img.redireccion !== '/' && img.redireccion !== ' ') {
              return (
                <a
                  href={img.redireccion}
                  rel="noopener noreferrer"
                  target={
                    img.redireccion.includes('www') || img.redireccion.includes('https')
                      ? '_blank'
                      : '_self'
                  }
                  title={img.imagen[0].file.title}
                  key={`o-payment__pay-safe__img${index}`}
                >
                  <img
                    className="o-payment__pay-safe__img__placetopay"
                    src="https://static.placetopay.com/placetopay-logo.svg"
                    alt={img.imagen[0].file.title}
                    title={img.imagen[0].file.title}
                  />
                </a>
              );
            }
            if (img.imagen[0].title === 'ver preguntas frecuentes') {
              return (
                <div
                  className="o-payment__pay-safe__img__frecuentQuestions"
                  onClick={() => downloadFile(img.imagen[0].file.url)}
                  key={`o-payment__pay-safe__img${index}`}
                >
                  <p>
                    {img.nombre} <span>{img.subtitulo}</span>
                  </p>
                </div>
              );
            }
            return (
              <img
                key={`o-payment__pay-safe__img${index}`}
                src={img.imagen[0].file.url}
                alt={img.imagen[0].file.title}
                title={img.imagen[0].file.title}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
